import React from 'react';
import Lottie from 'lottie-react';
import success from '../../../constants/success.json';
import Button from 'components/Form/Button';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { fetchUserInformation } from 'thunks/account-thunk';
import clsx from 'clsx';

type Props = {
  title: string;
  showActionButton?: boolean;
  actionLink?: string;
  buttomText?: string;
  buttonText?: string;
  useCustomCss?: boolean;
  animine?: any;
};

export default function Successful({
  title,
  showActionButton,
  actionLink,
  buttomText,
  buttonText,
  useCustomCss,
  animine
}: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const goToOnBoarding = () => {
    dispatch(fetchUserInformation());
    navigate(actionLink || '');
  };

  return (
    <div
      className={clsx({
        'mx-32 my-10 mt-10 flex flex-col items-center justify-center px-40':
          useCustomCss,
        'mx-0 my-5 mt-0 flex w-full flex-col items-center justify-center px-0':
          !useCustomCss
      })}
    >
      <div
        className={`w-full rounded-[10px] border-2 border-[#E2E5EE] ${
          useCustomCss ? 'bg-white' : ''
        }`}
      >
        <div className="border-b p-6 text-center"></div>

        <div className="flex flex-col items-center justify-between py-10 font-circular text-2xl font-bold text-[#353535]">
          <p className="mb-5">{title}</p>
          <Lottie animationData={animine || success} style={{ height: 400 }} />
          <div className="mt-10">
            {showActionButton && (
              <Button
                variant="primary"
                size="md"
                className="mb-3 w-full rounded px-[1.5rem] py-2"
                label={buttonText}
                onClick={() => goToOnBoarding()}
              ></Button>
            )}
            {!showActionButton && <p>{buttomText}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
